export default function truthy(value) {
  return !!value
}
